<div class="px-3 py-5 bg-white rounded-lg shadow-cardShadow card-size">
  <ng-container *ngIf="loading">
    <div class="flex items-center justify-center h-full py-10">
      <app-loading-indicator [size]="32"></app-loading-indicator>
    </div>
  </ng-container>
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="projectProposalDetails; else noDetails">
      <div>
        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-id">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-id-label">Id</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-id-value">{{ projectProposalDetails?.id | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="designation">
          <div class="lg:w-1/3">
            <p class="font-bold" id="designation-label">Designation</p>
          </div>
          <div class="lg:w-2/3">
            <p id="designation-value">{{ projectProposalDetails?.designation | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-title">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-title-label">Title</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-title-value">{{ projectProposalDetails?.title | displayDash }}</p>
          </div>
        </div>



        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-number">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-number-label">Proposal Number</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-number-value">{{ projectProposalDetails?.proposalNumber | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proponent-name">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proponent-name-label">Proponent Name</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proponent-name-value">{{ projectProposalDetails?.proponentName | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-status">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-status-label">Proposal Status</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-status-value">{{ projectProposalDetails?.proposalStatus | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-cancellation-reasons">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-cancellation-reasons-label">Proposal Cancellation Reasons</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-cancellation-reasons-value">{{ projectProposalDetails?.proposalCancellationReasons | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proposal-submitted-date">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposal-submitted-date-label">Submitted Date</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposal-submitted-date-value">{{ projectProposalDetails?.proposalSubmittedDate | dateFormat }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="submitted-on-behalf">
          <div class="lg:w-1/3">
            <p class="font-bold" id="submitted-on-behalf-label">Submitted On Behalf Of Nominating Organisation</p>
          </div>
          <div class="lg:w-2/3">
            <p id="submitted-on-behalf-value">{{ projectProposalDetails?.submittedOnBehalfOfNominatingOrganisation | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="consultation-start-date">
          <div class="lg:w-1/3">
            <p class="font-bold" id="consultation-start-date-label">Consultation Start Date</p>
          </div>
          <div class="lg:w-2/3">
            <p id="consultation-start-date-value">{{ projectProposalDetails?.proposalConsultationStartDate | dateFormat }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="consultation-end-date">
          <div class="lg:w-1/3">
            <p class="font-bold" id="consultation-end-date-label">Consultation End Date</p>
          </div>
          <div class="lg:w-2/3">
            <p id="consultation-end-date-value">{{ projectProposalDetails?.proposalConsultationEndDate | dateFormat }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="approved-date">
          <div class="lg:w-1/3">
            <p class="font-bold" id="approved-date-label">Approved Date</p>
          </div>
          <div class="lg:w-2/3">
            <p id="approved-date-value">{{ projectProposalDetails?.proposalApprovedDate | dateFormat }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="completed-date">
          <div class="lg:w-1/3">
            <p class="font-bold" id="completed-date-label">Completed Date</p>
          </div>
          <div class="lg:w-2/3">
            <p id="completed-date-value">{{ projectProposalDetails?.proposalCompletedDate | dateFormat }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="project-number">
          <div class="lg:w-1/3">
            <p class="font-bold" id="project-number-label">Project Number</p>
          </div>
          <div class="lg:w-2/3">
            <p id="project-number-value">{{ projectProposalDetails?.projectNumber | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="project-type">
          <div class="lg:w-1/3">
            <p class="font-bold" id="project-type-label">Project Type</p>
          </div>
          <div class="lg:w-2/3">
            <p id="project-type-value">{{ projectProposalDetails?.projectType | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="project-pathway">
          <div class="lg:w-1/3">
            <p class="font-bold" id="project-pathway-label">Project Pathway</p>
          </div>
          <div class="lg:w-2/3">
            <p id="project-pathway-value">{{ projectProposalDetails?.projectPathway | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="project-status">
          <div class="lg:w-1/3">
            <p class="font-bold" id="project-status-label">Project Status</p>
          </div>
          <div class="lg:w-2/3">
            <p id="project-status-value">{{ projectProposalDetails?.projectStatus | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="existing-publication">
          <div class="lg:w-1/3">
            <p class="font-bold" id="existing-publication-label">Existing Publication to Revise/Amend</p>
          </div>
          <div class="lg:w-2/3">
            <p id="existing-publication-value">{{ projectProposalDetails?.existingPublicationToReviseOrAmend | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="national-committee">
          <div class="lg:w-1/3">
            <p class="font-bold" id="national-committee-label">National Committee</p>
          </div>
          <div class="lg:w-2/3">
            <p id="national-committee-value">{{ projectProposalDetails?.nationalCommittee | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="watermark-standard-proposal">
          <div class="lg:w-1/3">
            <p class="font-bold" id="watermark-standard-proposal-label">Is this a Watermark referenced Standard proposal?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="watermark-standard-proposal-value">{{ projectProposalDetails?.isThisaWatermarkReferencedStandardProposal | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="ncc-standard-proposal">
          <div class="lg:w-1/3">
            <p class="font-bold break-words" id="ncc-standard-proposal-label">
              Is this a National Construction Code (NCC) referenced<br>Standard proposal?
            </p>
          </div>
          <div class="lg:w-2/3">
            <p id="ncc-standard-proposal-value">{{ projectProposalDetails?.isThisaNationalConstructionCodeNCCReferencedStandardProposal | displayDash }}
            </p>
          </div>
        </div>


        <div class="flex flex-col mt-4 lg:flex-row" id="publication-changes">
          <div class="lg:w-1/3">
            <p class="font-bold" id="publication-changes-label">Why does publication need changes?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="publication-changes-value">{{ projectProposalDetails?.whyDoesPublicationNeedChanges | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="issues-current-edition">
          <div class="lg:w-1/3">
            <p class="font-bold" id="issues-current-edition-label">What are the issues with current edition?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="issues-current-edition-value">{{ projectProposalDetails?.whatAreTheIssuesWithCurrentEdition | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="intended-users">
          <div class="lg:w-1/3">
            <p class="font-bold" id="intended-users-label">Who are the intended users of the document?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="intended-users-value">{{ projectProposalDetails?.whoAreTheIntendedUsersOfTheNewDocument | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="intended-users-modified">
          <div class="lg:w-1/3">
            <p class="font-bold" id="intended-users-modified-label">Who are the intended users of the modified document?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="intended-users-modified-value">{{ projectProposalDetails?.whoAreTheIntendedUsersOfTheModifiedDocument | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="evidence-exists">
          <div class="lg:w-1/3">
            <p class="font-bold" id="evidence-exists-label">What evidence exists?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="evidence-exists-value">{{ projectProposalDetails?.whatEvidenceExists | displayDash }}</p>
          </div>
        </div>

        <div class="flex flex-col mt-4 lg:flex-row" id="proposed-solution">
          <div class="lg:w-1/3">
            <p class="font-bold" id="proposed-solution-label">What is your Proposed Solution?</p>
          </div>
          <div class="lg:w-2/3">
            <p id="proposed-solution-value">{{ projectProposalDetails?.whatIsYourProposedSolution | displayDash }}</p>
          </div>
        </div>
      </div>
      <div *ngIf="projectProposalDetails" class="flex justify-end pt-4">
        <app-back-to-top id="btn-back-to-top"></app-back-to-top>
      </div>
    </ng-container>

    <ng-template #noDetails>
      <div class="flex items-center justify-center h-full py-10">
        <p id="no-records-found">No records found</p>
      </div>
    </ng-template>
  </ng-container>
</div>

